import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import duckify, {currentCustomer} from "../../utils/duckify";
import {compose} from "redux";
import {titleize} from "../../utils";

/**
 * FormInboxNav is a navigation component that allows switching between Form Inbox views.
 *
 * @param view
 * @param userType
 * @returns {JSX.Element}
 */
const FormInboxNav = ({ view, userType, customer }) => {
  return <ul className="nav nav-pills flat-pill page-menu d-inline-flex">
    <li className={classNames('first', { active: view === 'default' })}>
      <Link href="/forms_inbox">Inbox</Link>
    </li>

    <li className={classNames({ active: view === 'drafts' })}>
      <Link href="/forms_inbox/drafts/parent">Draft {customer && titleize(customer.admin_admissions_terms['noun'])}s</Link>
    </li>

    <li className={classNames({ active: view === 'imported' })}>
      <Link href="/forms_inbox/imported">Recently Imported</Link>
    </li>

    {view === 'drafts' && <React.Fragment>
      <li className="divider"/>
      <li>
        <div className="sub-menu">
          <span className="italic medium-grey">Entered by:</span>
          {' '}<Link className={classNames({ active: userType === 'admin' })}
                     to="/forms_inbox/drafts/admin">Admins</Link>
          {' '}<span className="italic medium-grey">or</span>
          {' '}<Link className={classNames({ active: userType === 'parent' })}
                     to="/forms_inbox/drafts/parent">Parents</Link>
        </div>
      </li>
    </React.Fragment>}
  </ul>;
};

FormInboxNav.propTypes = {
  userType: PropTypes.oneOf(['admin', 'parent']),
  view: PropTypes.oneOf(['default', 'drafts', 'imported']),
};

const mapDucksToProps = () => ({
  customer: currentCustomer
});

export default compose(
  duckify(mapDucksToProps, () => ({}), () => ({}))
)(FormInboxNav);
